/* eslint-disable @typescript-eslint/naming-convention */

import { gql } from "@apollo/client";

export const GET_USER_FIELDS = gql`
  fragment GetUserFields on User {
    name
    sub
    userHandle {
      renderedForm
    }
    profilePhoto {
      publicId
    }
  }
`;
export const GET_ASSOCIATED_TAWK_INFO = gql`
  fragment GetAssociatedTawkInfo on TawkCandidate {
    title
    generatedVideo {
      publicId
    }
  }
`;
export const GET_REPOSTED_TAWK_INFO = gql`
  fragment GetRepostedTawkInfo on Post {
    repostedPost_id
    repostedTimeRange {
      endTime
      startTime
    }
  }
`;
export const GET_CLIP_POST_INFO = gql`
  ${GET_USER_FIELDS}
  ${GET_ASSOCIATED_TAWK_INFO}
  fragment GetClipPostInfo on Post {
    id
    createdAt
    text
    author {
      ...GetUserFields
    }
    associatedTawk {
      ...GetAssociatedTawkInfo
    }
  }
`;

export const postInfo = gql`
  ${GET_USER_FIELDS}
  ${GET_ASSOCIATED_TAWK_INFO}
  ${GET_REPOSTED_TAWK_INFO}
  ${GET_CLIP_POST_INFO}
  fragment PostInfo on Post {
    createdAt
    text
    associatedTawk {
      title
      createdAt
      generatedVideo {
        publicId
      }
      rawAudio {
        publicId
      }
    }
    author {
      ...GetUserFields
    }
    likesCount
    repliesCount
    id
    ...GetRepostedTawkInfo
    repostedPost {
      ...GetClipPostInfo
    }
  }
`;

export const postCollectionInfo = gql`
  ${GET_USER_FIELDS}
  ${GET_ASSOCIATED_TAWK_INFO}
  ${postInfo}
  fragment PostCollectionInfo on PostCollection {
    id
    description
    name
    updatedAt
    author {
      ...GetUserFields
    }
    color {
      blue
      green
      red
    }
    emoji
    memberships(sortDirection: DESC) {
      items {
        post {
          ...PostInfo
        }
      }
    }
  }
`;

export const CloudinaryResourceInfo = gql`
  fragment CloudinaryResourceInfo on CloudinaryResource {
    publicId
  }
`;

export const UserInfoV2 = gql`
  ${CloudinaryResourceInfo}
  fragment UserInfoV2 on User {
    sub
    name
    bio
    userHandle {
      standardForm
      renderedForm
    }
    profilePhoto {
      ...CloudinaryResourceInfo
    }
  }
`;

export const TawkInfoV2 = gql`
  ${CloudinaryResourceInfo}
  ${UserInfoV2}
  fragment TawkInfoV2 on TawkCandidate {
    # The components of the composite key
    ownerSub
    localId
    tawkVersion
    title
    createdAt
    author {
      ...UserInfoV2
    }
    duration

    rawAudio {
      ...CloudinaryResourceInfo
    }
    processedAudio {
      ...CloudinaryResourceInfo
    }
    generatedVideo {
      ...CloudinaryResourceInfo
    }
  }
`;

export const GenericImageInfo = gql`
  ${CloudinaryResourceInfo}
  fragment GenericImageInfo on GenericImage {
    imageUrl
    cloudinaryImage {
      ...CloudinaryResourceInfo
    }
  }
`;

export const ExternalTawkInfo = gql`
  ${GenericImageInfo}
  ${UserInfoV2}
  fragment ExternalTawkInfo on ExternalTawk {
    id

    inserter_sub
    inserter {
      ...UserInfoV2
    }

    title
    audioFileUrl
    duration

    originUrl
    originKind
    originName
    originCreatedAt

    picture {
      ...GenericImageInfo
    }

    createdAt
  }
`;

export const PostInfoV2NonRecursive = gql`
  ${GET_USER_FIELDS}
  ${GET_ASSOCIATED_TAWK_INFO}
  ${GET_REPOSTED_TAWK_INFO}
  ${GET_CLIP_POST_INFO}
  ${TawkInfoV2}
  ${ExternalTawkInfo}
  fragment PostInfoV2NonRecursive on Post {
    createdAt
    text
    associatedTawk {
      ...TawkInfoV2
    }
    associatedExternalTawk {
      ...ExternalTawkInfo
    }
    author {
      ...GetUserFields
    }
    likesCount
    repliesCount
    id
    ...GetRepostedTawkInfo
    repostedPost {
      ...GetClipPostInfo
    }
    associatedColorHue
    footnote
  }
`;

export const PostInfoV2 = gql`
  ${PostInfoV2NonRecursive}

  fragment PostInfoV2 on Post {
    ...PostInfoV2NonRecursive
    repostedPost {
      ...PostInfoV2NonRecursive
    }
    repostedTimeRange {
      startTime
      endTime
    }
  }
`;

export const PostInfoV2WithDerivatives = gql`
  ${PostInfoV2}

  fragment PostInfoV2WithDerivatives on Post {
    ...PostInfoV2

    replies(sortDirection: DESC, limit: 10) {
      items {
        ...PostInfoV2
      }
    }
    reposts(sortDirection: DESC, limit: 10) {
      items {
        ...PostInfoV2
      }
    }
  }
`;

export const PostCollectionInfoV2 = gql`
  ${UserInfoV2}
  fragment PostCollectionInfoV2 on PostCollection {
    id
    description
    name
    updatedAt
    author {
      ...UserInfoV2
    }
    defaultSortOrder
  }
`;
